/**
 * Potencia item
 * @param {*} editor
 */
function angle(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `\\widehat{${text}}`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Ángulo',
    action: angle,
    className: 'angleicon',
    title: 'Ángulo',
  };

  return option;
}
